import React from 'react';
import { useForm } from 'react-final-form';
import { pickAll } from 'ramda';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';
import { Checkbox } from '@interlayer/js/components/common/Fields/Checkbox';

import { useTranslations } from '@core/js/hooks/i18n';
import { clsb } from '@core/js/utils/classNames.util';

import {
    MARKETING_CHECKBOXES_FRONT,
    SELECT_ALL_FIELD } from '@interlayer/js/app/components/main/MarketingPreferences/constants';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TMarketingCheckboxesBareProps } from './types';

import style from '../../MarketingCheckboxes.scss';

export const MarketingCheckboxesBare: React.FC<TMarketingCheckboxesBareProps> = ({
    contactTypes,
    products = [],
    isSelectAll = true,
    isProductTitleHidden = false,
    classNames,
    onChange
}) => {
    const form = useForm();
    const buildCls = clsb([style, classNames]);
    const t = useTranslations('playtech.mobile.system.marketingCheckboxes.label.');

    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange && onChange(event, form);

        if (!isSelectAll) {
            return;
        }

        const contactFields = pickAll(contactTypes, form.getState().values);
        const isAllContactChecked = Object.values(contactFields).every(item => Boolean(item));

        form.change(SELECT_ALL_FIELD, isAllContactChecked);
    };

    return (
        <>
            {!isProductTitleHidden && (
                <div className={style.productTitleContainer}>
                    {products.map(product => (
                        <div key={product} className={style.productTitle}>
                            <span className={style.productTitleWrapper}>
                                {t(product)}
                            </span>
                        </div>
                    ))}
                </div>
            )}

            {
                contactTypes.map((checkboxName) => (
                    <div key={checkboxName} className={style.checkboxContainer}>
                        <div className={style.toggleIconContainer}>
                            <SvgIcon
                                type={MARKETING_CHECKBOXES_FRONT[checkboxName].icon}
                                className={clsx(style.toggleIcon, style[checkboxName])}
                            />

                            <span className={style.passiveLabel}>
                                {t(checkboxName)}
                            </span>
                        </div>

                        {products.map((product) => (
                            <Checkbox
                                key={`${product}_${checkboxName}`}
                                reverse
                                kind="toggle"
                                name={`${product}_${checkboxName}`}
                                handlerOnChange={handlerOnChange}
                                classNames={{
                                    checkbox: buildCls(['checkbox']),
                                    label: buildCls(['checkboxLabel']),
                                    control: buildCls(['checkboxControl'])
                                }}
                            />
                        )
                        )}
                    </div>
                ))
            }
        </>
    );
};
